var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemoteWork = function SvgRemoteWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#remote-work_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.688 11.813H4.375A3.066 3.066 0 0 1 1.313 8.75v-.875h.875v.875a2.19 2.19 0 0 0 2.187 2.188h1.313zM10.938 11.813h-1.75a.876.876 0 0 1-.876-.876v-1.75c0-.482.393-.874.876-.874h1.75c.482 0 .874.392.874.874v1.75a.876.876 0 0 1-.874.876M9.187 9.187v1.75h1.75v-1.75zM11.813 6.563h-.876v.875h.876zM13.563 8.313h-.876v.874h.876zM13.563 10.063h-.876v.874h.876zM7.438 9.188h-.875v.874h.875zM7.438 10.938h-.875v.874h.875zM7.438 12.688h-.875v.874h.875zM9.188 12.688h-.876v.874h.876zM11.813 5.688v-.875A3.066 3.066 0 0 0 8.75 1.75H5.688v.875H8.75a2.19 2.19 0 0 1 2.188 2.188v.875zM4.375 3.5V1.75A.875.875 0 0 0 3.5.875H.875v5.688h.875V4.374h.648L3.42 6.563h.954l-1.02-2.188H3.5a.875.875 0 0 0 .875-.875M1.75 1.75H3.5V3.5H1.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "remote-work_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgRemoteWork;